import React from 'react';
import { aOrAn } from '../../../utilities';
import { Category } from '../../../constants';
import { CoverageScreenType } from './coverage-type';
import { DescriptionDisplay } from '../description-display';

const defaultCoveredDescription = [
  'Schedule an appointment with an in-network repair shop to diagnose your issue.',
  `They'll work with our coverage provider, SilverRock™, to confirm that your repairs are covered.`,
];

const baseText = (repairType = 'repair') => [
  `Get service at a shop recommended by us, or find a nearby ${repairType} shop that works for you.`,
];

export const CoverageScreenDescription = {
  contactUs: () => ['One of our Advocates may be able to resolve your issue.'],
  limited100Covered: () => defaultCoveredDescription,
  manufacturerCovered: (make: string) => [
    `Schedule an appointment with ${aOrAn(make)} ${make} dealership to get a diagnostic.`,
  ],
  carvanaCareCovered: () => defaultCoveredDescription,
  notCovered: (category: string) => {
    if (category === Category.Battery)
      return ['Items such as tires, brakes or batteries are not covered.', ...baseText()];
    if (category === Category.Maintenance)
      return [
        `Maintenance items like oil changes, tire rotations, wiper blade replacement and fluid changes aren't covererd.`,
        ...baseText(),
      ];
    if (category === Category.TiresOrBrakes)
      return ['Items such as tires, brakes or batteries are not covered.', ...baseText()];
    return baseText();
  },
  thirtyDayCovered: (date: string) => {
    return [
      `Schedule an appointment with an in-network repair shop to diagnose your issue by ${date}.`,
      `They'll work with our coverage provider, SilverRock™, to confirm your covered repairs.`,
    ];
  },
  carvanaCareOilTireCovered: () => defaultCoveredDescription,
  conditionallyCoveredBrakes: () => [
    'Wearable components such as brake pads and rotors are excluded for your coverage.',
    `Schedule an appointment with an in-network repair shop to diagnose your issue. They'll work with our coverage provider, SilverRock™, to verify your issue and make a determination.`,
  ],
  notCoveredCosmetic: () => ['Get service at a shop recommended by us, or find a nearby body shop that works for you.'],
  notCoveredGlass: () => ['Glass issues or defects are not covered.', ...baseText()],
  notCoveredAdditionalCosmetic: () => [
    `You've submitted the max amount of cosmetic concerns within your 7-Day Money Back Guarantee.`,
    ...baseText('body'),
  ],
  notCoveredAdditionalKey: () => [`We've got a partner recommendation for you to check out.`],
  notCoveredMissingAccessories: (make: string) => [
    `We recommend visiting ${make}'s website or a local store to replace any missing accessories.`,
  ],
  cosmeticSubmitted: () => ['We will email you within 48 hours with next steps.'],
};

export const getDescription = (
  coverageScreenType: CoverageScreenType,
  make,
  selectedWarranty,
  userSelections,
  carvanaCare
): string[] | JSX.Element | undefined => {
  return (
    <DescriptionDisplay
      coverageScreenType={coverageScreenType}
      make={make}
      selectedWarranty={selectedWarranty}
      userSelections={userSelections}
      carvanaCare={carvanaCare}
    />
  );
};
